(function () {
    'use strict';
    var controllerId = 'competenzaDigitaleAddEdit';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '$filter', 'datacontext', 'common', '_', 'competenza', competenzaDigitaleAddEditFn]);

    function competenzaDigitaleAddEditFn($scope, $uibModalInstance, $filter, datacontext, common, _, competenza) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.competenza = competenza;

        if ($scope.competenza.Id == 0) { 
            $scope.titolo = 'New Computer Skill';        
        }
        else { 
            $scope.titolo = 'Edit Computer Skill';
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                if ($scope.competenza.Id == 0) {
                    addItem($scope.competenza).then(function (result) {
                        if (result)
                            $uibModalInstance.close(result);
                    });
                }
                else { 
                    editItem($scope.competenza).then(function (result) { 
                        if (result)
                            $uibModalInstance.close(result);
                    });
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Modifica elemento
        function editItem(item) {
            return datacontext.competenzaDigitale_update(item).then(function (data) {
                if (data == "400") {
                    logError("Errore durante la creazione del dato");
                    return null;
                }
                return data;  
            });
        }

        // Aggiunta elemento
        function addItem(item) {
            return datacontext.competenzaDigitale_add(item).then(function (data) {
                if (data == "400") {
                    logError("Errore durante la creazione del dato");
                    return null;
                }

                return data; 
            });
        }
    }
})();